// REST-Clients fuer die Board-Routen aus backend/src/boards/routes.ts.

import { api } from "../lib/api.js";

export interface BoardDto {
  id: string;
  name: string;
  ownerId: string;
  status: "active" | "archived";
  methodTemplate: string | null;
  createdAt: string;
  updatedAt: string;
}

export type ListStatus = "active" | "archived" | "all";

export interface MemberDto {
  userId: string;
  displayName: string;
  email: string;
  role: "owner" | "editor";
  addedAt: string;
}

export const boardsApi = {
  list: (status: ListStatus = "active") =>
    api.get<{ boards: BoardDto[] }>(`/api/boards?status=${status}`).then((r) => r.boards),
  get: (id: string) => api.get<{ board: BoardDto }>(`/api/boards/${id}`).then((r) => r.board),
  create: (input: { name: string; methodTemplate: string | null }) =>
    api.post<{ board: BoardDto }>("/api/boards", input).then((r) => r.board),
  rename: (id: string, name: string) =>
    api.patch<{ board: BoardDto }>(`/api/boards/${id}`, { name }).then((r) => r.board),
  archive: (id: string) =>
    api.post<{ board: BoardDto }>(`/api/boards/${id}/archive`, {}).then((r) => r.board),
  listMembers: (id: string) =>
    api.get<{ members: MemberDto[] }>(`/api/boards/${id}/members`).then((r) => r.members),
  addMember: (id: string, userId: string, role: "editor" = "editor") =>
    api
      .post<{ member: MemberDto }>(`/api/boards/${id}/members`, { userId, role })
      .then((r) => r.member),
  removeMember: (id: string, userId: string) =>
    api.del<void>(`/api/boards/${id}/members/${userId}`),
};
